import { hashHistory } from 'react-router';

// Get 'app' path
import { path as CPM_PATH } from '../..';

// All paths
const PATHS = {
  ACCOUNTS: 'accounts',
};

// Exported paths
export const ACCOUNTS_PATH = PATHS.ACCOUNTS;

export const listPath = () => `${CPM_PATH}/${ACCOUNTS_PATH}`;
export const navigateToList = () => {
  hashHistory.push(listPath());
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/navigation.js